import { useCallback, useMemo } from "react";

import { getPackageHrefWithPromoCode } from "app/components/discountCampaign/DiscountBanner/utils/getPackageHrefWithPromoCode";
import type { IModalProps } from "app/components/hooks/useDiscounts";
import { useDiscounts } from "app/components/hooks/useDiscounts";

import {
    FIRST_WEEK_MONTHLY_CAMPAIGN_CTA,
    FIRST_WEEK_PROMO_CODE,
    FIRST_WEEK_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL,
} from "./configs/FirstWeekCampaignConfig";

interface IUseFirstWeekCampaignAPI {
    hasFirstWeekCta: boolean;
    firstWeekCtaType: string | null;
    onFirstWeekCtaClick: () => void;
    discountModalProps: IModalProps | null;
}

export const useFirstWeekCampaign = (): IUseFirstWeekCampaignAPI => {
    const { hasDiscountCampaign, discountModalProps } = useDiscounts();

    const firstWeekCtaType = useMemo((): string | null => {
        if (!hasDiscountCampaign) {
            return null;
        }
        return FIRST_WEEK_MONTHLY_CAMPAIGN_CTA;
    }, [hasDiscountCampaign]);

    const onFirstWeekCtaClick = useCallback(() => {
        if (!firstWeekCtaType) {
            return;
        }
        window.open(getPackageHrefWithPromoCode(FIRST_WEEK_PROMO_CODE, FIRST_WEEK_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL));
    }, [firstWeekCtaType]);

    return {
        hasFirstWeekCta: firstWeekCtaType !== null,
        firstWeekCtaType,
        onFirstWeekCtaClick,
        discountModalProps,
    };
};
